import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { history } from '../store'
import AppTimeHeader from '../containers/AppTimeHeader'
import { withNamespaces } from "react-i18next"
import { Modal, ModalBody } from 'reactstrap'
import StepBarTime from '../components/StepBarTime'
import { CheckCircle, Download } from 'lucide-react'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import { postTimeRent, fetchTimeOpenStatus, postTimeOpen } from '../actions/qrstime'
import { postRedsysGetParams, fetchCustomer, postQrsale } from '../actions/qrstime'

// pdfmake font setup
if (pdfFonts && pdfFonts.pdfMake) {
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
} else {
  pdfMake.vfs = pdfFonts;
}

const TICKET_KEY = 'vacway_time_ticket';

class TicketTimeView extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      accessCode: null,
      rentedTime: null,
      courtesyTime: null,
      openingId: null,
      remoteActionId: null,
      isRentProcessed: false,
      isOpenPopup: false,
      isOpening: false,
      isOpened: false,
      openError: false,
      lockerMustOpen: true,
      isReload: false,
      minutes: 5,
      seconds: 0,
      autorized: false,
      iva: 21,
      importeBase: null,
      importeIva: null,
      total: null,
      lockerInvoice: null,
      customerData: null,
      rentStartTime: null,
      gpAuthCode: null,
    }
  }

  getButtonStyle() {
    const { qrData } = this.props;
    const buttonColor1 = qrData?.headerConfig?.buttonColor1 || '#01315f';
    const buttonColor2 = qrData?.headerConfig?.buttonColor2 || '#067ddb';
    const buttonText = qrData?.headerConfig?.buttonText || '#ffffff';

    return {
      background: `linear-gradient(135deg, ${buttonColor1}, ${buttonColor2})`,
      color: buttonText,
      border: 'none'
    };
  }

  getPrimaryColor() {
    const { qrData } = this.props;
    return qrData?.headerConfig?.primaryColor || '#01315f';
  }

  getLockerType(type) {
    const names = {
      'BNS': 'Standard',    'CNS': 'Standard Carga',
      'BWS': 'Standard XL', 'CWS': 'Standard Carga XL',
      'BNM': 'Medium',      'CNM': 'Medium Carga',
      'BWM': 'Medium XL',   'CWM': 'Medium Carga XL',
      'BNL': 'Large',       'CNL': 'Large Carga',
      'BWL': 'Large XL',    'CWL': 'Large Carga XL',
      'BNXL': 'Large',      'CNXL': 'Large Carga',
      'BWXL': 'Large XL',   'CWXL': 'Large Carga XL',
      'BN2XL': 'Large',     'CN2XL': 'Large Carga',
      'BW2XL': 'Large XL',  'CW2XL': 'Large Carga XL',
      'BN3XL': 'Ski',       'CN3XL': 'Ski Carga',
      'BW3XL': 'Ski XL',    'CW3XL': 'Ski Carga XL',
    };
    return names[type] || type;
  }

  handleDownloadInvoice = () => {
    const { customerData, importeBase, importeIva, total, iva, lockerInvoice } = this.state;
    const p = new URLSearchParams(this.props.location.search);

    const lockerMatricula = p.get('lockerMatricula');
    const selectedLocker  = p.get('selectedLocker');
    const phoneNumber     = p.get('phoneNumber');
    const customerName    = decodeURIComponent(p.get('customerName') || '');
    const customerEmail   = decodeURIComponent(p.get('customerEmail') || '');
    const totalMinutes    = parseInt(p.get('totalMinutes') || '0');
    const paymentId       = p.get('paymentId');
    const rawDate         = p.get('paymentDate');
    const lockerCustomer  = p.get('lockerCustomer');

    const invoiceNumber = lockerInvoice || `M5-${paymentId}`;
    const invoiceDate   = rawDate
      ? new Date(decodeURIComponent(rawDate)).toLocaleDateString('es-ES')
      : new Date().toLocaleDateString('es-ES');

    const hours = Math.floor(totalMinutes / 60);
    const mins  = totalMinutes % 60;
    const timeDisplay = hours > 0 ? (mins > 0 ? `${hours}h ${mins}min` : `${hours}h`) : `${mins}min`;

    const providerName    = customerData?.Social_name || customerData?.Fullname || lockerCustomer || 'VACWAY S.L.';
    const providerTaxId   = customerData?.Invoice_taxid || '';
    const providerAddress = customerData?.Invoice_address || customerData?.Address || '';

    const docDefinition = {
      pageSize: 'A4',
      pageMargins: [50, 60, 50, 60],
      styles: {
        header:      { fontSize: 20, bold: true, color: '#01315f' },
        invoiceTitle:{ fontSize: 16, bold: true, color: '#01315f' },
        label:       { fontSize: 8,  color: '#999', bold: true },
        tableHeader: { fontSize: 9,  bold: true, color: '#ffffff', fillColor: '#01315f' },
        tableCell:   { fontSize: 10 },
        totalLabel:  { fontSize: 11, bold: true },
        footer:      { fontSize: 8,  color: '#aaa', italics: true },
      },
      content: [
        {
          columns: [
            { text: providerName, style: 'header', width: '*' },
            {
              stack: [
                { text: 'FACTURA', style: 'invoiceTitle', alignment: 'right' },
                { text: `Nº ${invoiceNumber}`, fontSize: 10, color: '#555', alignment: 'right', margin: [0, 2, 0, 0] },
                { text: invoiceDate, fontSize: 9, color: '#999', alignment: 'right' },
              ],
              width: 'auto',
            },
          ],
          margin: [0, 0, 0, 8],
        },
        { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 495, y2: 0, lineWidth: 1.5, lineColor: '#01315f' }], margin: [0, 0, 0, 18] },
        {
          columns: [
            {
              stack: [
                { text: 'EMISOR', style: 'label', margin: [0, 0, 0, 4] },
                { text: providerName, fontSize: 10, bold: true },
                providerTaxId   ? { text: `CIF/NIF: ${providerTaxId}`, fontSize: 10, margin: [0, 1, 0, 0] } : null,
                providerAddress ? { text: providerAddress, fontSize: 10, margin: [0, 1, 0, 0] } : null,
              ].filter(Boolean),
              width: '50%',
            },
            {
              stack: [
                { text: 'CLIENTE', style: 'label', margin: [0, 0, 0, 4] },
                { text: customerName || '-', fontSize: 10, bold: true },
                customerEmail ? { text: customerEmail, fontSize: 10, margin: [0, 1, 0, 0] } : null,
                phoneNumber   ? { text: phoneNumber,   fontSize: 10, margin: [0, 1, 0, 0] } : null,
              ].filter(Boolean),
              width: '50%',
            },
          ],
          margin: [0, 0, 0, 22],
        },
        {
          table: {
            headerRows: 1,
            widths: ['*', 70, 70, 70],
            body: [
              [
                { text: 'DESCRIPCIÓN',  style: 'tableHeader', margin: [6, 7, 6, 7] },
                { text: 'TIEMPO',       style: 'tableHeader', alignment: 'center', margin: [6, 7, 6, 7] },
                { text: 'TAQUILLA',     style: 'tableHeader', alignment: 'center', margin: [6, 7, 6, 7] },
                { text: 'IMPORTE',      style: 'tableHeader', alignment: 'right',  margin: [6, 7, 6, 7] },
              ],
              [
                { text: `Alquiler de taquilla · ${this.getLockerType(selectedLocker)}`, style: 'tableCell', margin: [6, 6, 6, 6] },
                { text: timeDisplay,              style: 'tableCell', alignment: 'center', margin: [6, 6, 6, 6] },
                { text: `Nº ${lockerMatricula}`,  style: 'tableCell', alignment: 'center', margin: [6, 6, 6, 6] },
                { text: `${(importeBase || 0).toFixed(2)} €`, style: 'tableCell', alignment: 'right', margin: [6, 6, 6, 6] },
              ],
            ],
          },
          layout: 'lightHorizontalLines',
          margin: [0, 0, 0, 0],
        },
        {
          columns: [
            { text: '', width: '*' },
            {
              table: {
                widths: [120, 70],
                body: [
                  [{ text: 'Base imponible', fontSize: 10, margin: [4, 5, 4, 5] }, { text: `${(importeBase || 0).toFixed(2)} €`, fontSize: 10, alignment: 'right', margin: [4, 5, 4, 5] }],
                  [{ text: `IVA (${iva}%)`,  fontSize: 10, margin: [4, 5, 4, 5] }, { text: `${(importeIva  || 0).toFixed(2)} €`, fontSize: 10, alignment: 'right', margin: [4, 5, 4, 5] }],
                  [{ text: 'TOTAL', style: 'totalLabel', margin: [4, 7, 4, 7] },   { text: `${(total || 0).toFixed(2)} €`, style: 'totalLabel', alignment: 'right', margin: [4, 7, 4, 7] }],
                ],
              },
              layout: 'lightHorizontalLines',
              margin: [0, 8, 0, 0],
            },
          ],
        },
        ...(this.state.gpAuthCode
          ? [{ text: `Autorización de pago: ${this.state.gpAuthCode}`, fontSize: 9, color: '#666', margin: [0, 10, 0, 0] }]
          : []),
        { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 495, y2: 0, lineWidth: 0.5, lineColor: '#ccc' }], margin: [0, 28, 0, 10] },
        { text: `Documento generado electrónicamente · ${invoiceDate} · www.vacway.es`, style: 'footer', alignment: 'center' },
      ],
    };

    pdfMake.createPdf(docDefinition).download(`factura_${invoiceNumber}.pdf`);
  }

  componentDidMount() {
    window.addEventListener('beforeunload', this.handleBeforeUnload);

    // Block all React Router navigation while the locker still needs to be opened.
    // history.block intercepts both browser back and programmatic push/replace.
    this.unblockHistory = history.block(() => {
      if (this.state.lockerMustOpen && this.state.isRentProcessed) {
        return false; // returning false cancels the navigation
      }
    });

    // Also block the browser's native back button
    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', this.handlePopState);

    const urlParams = new URLSearchParams(this.props.location.search);
    const lockerAssigned  = urlParams.get('lockerAssigned');
    const lockerMatricula = urlParams.get('lockerMatricula');
    const lockerPrice     = parseFloat(urlParams.get('lockerPrice'));
    const totalMinutes    = parseInt(urlParams.get('totalMinutes'));
    const qrToken         = urlParams.get('qrToken');
    const qrType          = urlParams.get('qrType');
    const phoneNumber     = urlParams.get('phoneNumber');
    const customerEmail   = decodeURIComponent(urlParams.get('customerEmail') || '');
    const paymentId       = urlParams.get('paymentId');
    const courtesyTime    = parseInt(urlParams.get('courtesyTime') || '5');
    const ticketIVA       = parseFloat(urlParams.get('ticketIVA') || '21');
    const language        = urlParams.get('language') || 'es';
    const lockerCustomerID = urlParams.get('lockerCustomerID');
    const paymentDate     = new Date(decodeURIComponent(urlParams.get('paymentDate') || ''));
    // Addon Payments landings carry the receipt data as plain params —
    // already validated server-side by qrs/gp-response before redirecting here.
    // The URL survives reloads, so no sessionStorage persistence is needed.
    const gpAuthCode      = urlParams.get('gpAuthCode');
    const gpPasRef        = urlParams.get('gpPasRef');
    // Redsys redirect appends its signed params to the OK URL
    const dsSignatureVersion   = urlParams.get('Ds_SignatureVersion');
    const dsMerchantParameters = urlParams.get('Ds_MerchantParameters');
    const dsSignature          = urlParams.get('Ds_Signature');

    if (this.props.i18n?.changeLanguage) this.props.i18n.changeLanguage(language);

    const iva         = ticketIVA;
    const total       = lockerPrice;
    const importeBase = parseFloat((total / (1 + iva / 100)).toFixed(2));
    const importeIva  = parseFloat((total - importeBase).toFixed(2));
    this.setState({ total, importeBase, importeIva, iva, courtesyTime, gpAuthCode });

    // Fetch customer data for PDF invoice (always, not gated)
    if (lockerCustomerID) {
      this.props.fetchCustomer(lockerCustomerID)
        .then(answer => {
          if (answer.response) this.setState({ customerData: answer.response });
        })
        .catch(console.error);
    }

    // ── Reload guard: restore from sessionStorage if ticket already processed ──
    const savedTicket = (() => {
      try { return JSON.parse(sessionStorage.getItem(TICKET_KEY)); } catch { return null; }
    })();

    if (savedTicket && savedTicket.lockerAssigned === lockerAssigned) {
      // Restore state from sessionStorage — no API call needed
      this.setState({
        accessCode:     savedTicket.accessCode,
        rentedTime:     savedTicket.rentedTime,
        courtesyTime:   savedTicket.courtesyTime || courtesyTime,
        rentStartTime:  savedTicket.rentStartTime,
        openingId:      savedTicket.openingId,
        remoteActionId: savedTicket.remoteActionId,
        lockerInvoice:  savedTicket.lockerInvoice || null,
        isRentProcessed: true,
        autorized: true,
        isReload: true,
      });
      return;
    }

    // ── First-time authorization: validate paymentDate is today ──
    const now = new Date();
    const isToday = paymentDate.getFullYear() === now.getFullYear()
      && paymentDate.getMonth() === now.getMonth()
      && paymentDate.getDate() === now.getDate();

    if (!isToday) {
      this.setState({ autorized: false });
      return;
    }

    this.setState({ autorized: true });

    const zoneSelected    = urlParams.get('zoneSelected') || '';
    const descriptionZone = decodeURIComponent(urlParams.get('descriptionZone') || '');
    const lockerCustomer  = decodeURIComponent(urlParams.get('lockerCustomer') || '');

    const processRent = () => {
      this.props.postTimeRent({
        lockerAssigned,
        phoneNumber,
        timeMinutes: totalMinutes,
        qrToken,
        lockerMatricula,
        lockerInvoice: `M5-${paymentId}`,
        paymentId,
        payment_date: paymentDate.toISOString(),
        customerEmail,
        language,
        zoneSelected,
        descriptionZone,
        lockerCustomer,
      })
      .then(answer => {
        const rental = answer.response;
        const ticketState = {
          accessCode:     rental.accessCode,
          rentedTime:     rental.rentedTime,
          courtesyTime:   rental.courtesyTime || courtesyTime,
          rentStartTime:  rental.rentStartTime || new Date().toISOString(),
          openingId:      rental.openingId,
          remoteActionId: rental.remoteActionId,
          lockerAssigned,
        };

        // Persist to sessionStorage so reload restores without hitting API again
        sessionStorage.setItem(TICKET_KEY, JSON.stringify(ticketState));

        this.setState({ ...ticketState, isRentProcessed: true });

        // Register sale (runs once — not on reload, sessionStorage restores instead)
        const madridNow   = new Date();
        const madridTime  = new Date(madridNow.toLocaleString('en-US', { timeZone: 'Europe/Madrid' }));
        const formattedDate = madridTime.toISOString().replace('T', ' ').substring(0, 19);

        // Seconds from QR scan (timer set in HomeView) to this ticket view —
        // same OperationTime metric the machine app reports.
        const opStart = Number(sessionStorage.getItem('vacway_op_start'));

        this.props.postQrsale({
          TimeStamp:     formattedDate,
          Amount:        parseInt(lockerPrice),
          Code:          qrToken,
          PaymentMethod: qrType === 'free' ? 'FREE' : 'QR',
          WorkerSession: '000000',
          Language:      language,
          RedsysCode:    paymentId,
          AuthCode:      (this._saleAuth && this._saleAuth.AuthCode) || '',
          PasRef:        (this._saleAuth && this._saleAuth.PasRef) || '',
          Locker:        lockerAssigned,
          LockerPin:     rental.lockerPass,
          Phone:         phoneNumber,
          Email:         customerEmail,
          OperationTime: opStart > 0 ? Math.round((Date.now() - opStart) / 1000) : 0,
        })
        .then(saleAnswer => {
          if (saleAnswer.response?.toSaveSale?.Code) {
            const invoiceCode = saleAnswer.response.toSaveSale.Code;
            this.setState({ lockerInvoice: invoiceCode });
            // Persist invoice code to sessionStorage too
            try {
              const stored = JSON.parse(sessionStorage.getItem(TICKET_KEY) || '{}');
              sessionStorage.setItem(TICKET_KEY, JSON.stringify({ ...stored, lockerInvoice: invoiceCode }));
            } catch { /* ignore */ }
          }
        })
        .catch(console.error);
      })
      .catch(console.error);
    };

    // Resolve the payment authorization BEFORE registering the rent+sale so
    // the Sale carries it (same behaviour as the rental flux). Never blocks:
    // any failure just processes the rent without auth data.
    const finishWithAuth = (auth) => {
      if (auth && auth.AuthCode && auth.AuthCode !== 'N/A') {
        this._saleAuth = auth;
        this.setState({ gpAuthCode: auth.AuthCode });
      }
      processRent();
    };

    if (qrType === 'free') {
      processRent();
    } else if (gpAuthCode) {
      // Addon Payments: validated server-side, delivered as plain params
      finishWithAuth({ AuthCode: gpAuthCode, PasRef: gpPasRef || '' });
    } else if (dsMerchantParameters && dsSignature && lockerCustomerID) {
      // Redsys redirect: decode the signed response with the customer's key
      this.props.fetchCustomer(lockerCustomerID)
        .then((customer) => this.props.postRedsysGetParams({
          Ds_SignatureVersion: dsSignatureVersion,
          Ds_MerchantParameters: dsMerchantParameters,
          Ds_Signature: dsSignature,
          parameterToFetch: 'all',
          secretKey: customer.response?.Redsys?.SECRETKEY,
        }))
        .then((answer) => finishWithAuth({
          AuthCode: answer.response?.decodedParams?.Ds_AuthorisationCode || '',
          PasRef: '',
        }))
        .catch(() => finishWithAuth(null));
    } else {
      finishWithAuth(null);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
    window.removeEventListener('popstate', this.handlePopState);
    if (this.unblockHistory) this.unblockHistory();
    clearInterval(this.countdownInterval);
    clearInterval(this.statusInterval);
  }

  handlePopState = () => {
    // Re-push state every time the user tries to go back, keeping them on this page
    window.history.pushState(null, '', window.location.href);
  }

  handleBeforeUnload = (e) => {
    if (this.state.lockerMustOpen && this.state.isRentProcessed) {
      e.preventDefault();
      e.returnValue = '';
    }
  }

  startOpenCountdown = () => {
    this.setState({ minutes: 5, seconds: 0 });
    this.countdownInterval = setInterval(() => {
      if (this.state.seconds > 0) {
        this.setState(prev => ({ seconds: prev.seconds - 1 }));
      } else {
        if (this.state.minutes > 0) {
          this.setState(prev => ({ minutes: prev.minutes - 1, seconds: 59 }));
        } else {
          clearInterval(this.countdownInterval);
        }
      }
    }, 1000);
  }

  toggleOpenPopup = () => {
    this.setState({ isOpenPopup: !this.state.isOpenPopup });
  }

  handleOpenLocker = () => {
    this.setState({ isOpening: true });
    this.startOpenCountdown();

    const searchParams = new URLSearchParams(this.props.location.search);
    const lockerAssigned = searchParams.get('lockerAssigned');

    const qrToken = searchParams.get('qrToken');

    // Send bleName + qrToken so API can set correct Qr code and Customer
    this.props.postTimeOpen({ bleName: lockerAssigned, qrToken })
    .then((answer) => {
      const openActionId = answer.response.openingId;

      // Poll for open status
      this.statusInterval = setInterval(() => {
        this.props.fetchTimeOpenStatus(openActionId)
          .then((statusAnswer) => {
            if (statusAnswer.response.status === 'COMPLETE' || statusAnswer.response.status === 'ONPROCESS') {
              clearInterval(this.statusInterval);
              clearInterval(this.countdownInterval);
              this.setState({
                isOpening: false,
                isOpened: true,
                lockerMustOpen: false,
              });
            } else if (statusAnswer.response.status === 'ERROR') {
              clearInterval(this.statusInterval);
              clearInterval(this.countdownInterval);
              this.setState({
                isOpening: false,
                openError: true,
              });
            }
          })
          .catch(console.error);
      }, 5000);

      // Timeout after 1 minute
      setTimeout(() => {
        if (this.statusInterval) {
          clearInterval(this.statusInterval);
          if (!this.state.isOpened) {
            this.setState({ isOpening: false, openError: true });
          }
        }
      }, 60000);
    })
    .catch((error) => {
      console.error(error);
      this.setState({ isOpening: false, openError: true });
    });
  }

  handleFinish = () => {
    sessionStorage.removeItem(TICKET_KEY);
    const searchParams = new URLSearchParams(this.props.location.search);
    const qrToken = searchParams.get('qrToken');
    history.push(`/qrsale/${qrToken}`);
  }

  render() {
    const { t } = this.props;
    const {
      accessCode, courtesyTime, isRentProcessed, rentStartTime, isReload,
      isOpenPopup, isOpening, isOpened, openError, lockerMustOpen,
      minutes, seconds, autorized, total, importeBase, importeIva, iva, lockerInvoice,
    } = this.state;

    const primaryColor = this.getPrimaryColor();
    const buttonStyle  = this.getButtonStyle();
    const iconsColor   = this.props.qrData?.headerConfig?.iconsColor || primaryColor || '#01315f';

    const p = new URLSearchParams(this.props.location.search);
    const lockerMatricula = p.get('lockerMatricula');
    const totalMinutes    = parseInt(p.get('totalMinutes') || '0');
    const phoneNumber     = p.get('phoneNumber');
    const selectedLocker  = p.get('selectedLocker');
    const customerEmail   = decodeURIComponent(p.get('customerEmail') || '');
    const customerName    = decodeURIComponent(p.get('customerName') || '');
    const qrToken         = p.get('qrToken');

    const hours = Math.floor(totalMinutes / 60);
    const mins  = totalMinutes % 60;
    const timeDisplay = hours > 0
      ? (mins > 0 ? `${hours}h ${mins}min` : `${hours}h`)
      : `${mins}min`;

    // Start / end times derived from rentStartTime saved by the API
    const fmtTime = (iso) => {
      if (!iso) return '--:--';
      return new Date(iso).toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
    };
    const rentEndTime = rentStartTime
      ? new Date(new Date(rentStartTime).getTime() + (totalMinutes + courtesyTime) * 60000).toISOString()
      : null;

    if (!autorized) {
      return (
        <div className="timeBackground">
          <AppTimeHeader />
          <div className="time-page-wrap">
            <div className="time-content time-center">
              <h3>{t('Sesión no válida')}</h3>
              <p>{t('Esta página ya ha sido procesada o la sesión ha expirado.')}</p>
            </div>
          </div>
        </div>
      );
    }

    if (!isRentProcessed) {
      return (
        <div className="timeBackground">
          <AppTimeHeader />
          <div className="time-page-wrap">
            <div className="time-content time-center">
              <div className="spinner"><img src="/images/logo.png" alt="Logo" /></div>
              <p style={{ marginTop: '16px' }}>{t('Procesando tu reserva...')}</p>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="timeBackground">
        <AppTimeHeader />
        <div className="time-page-wrap">
          <div className="time-content time-locker-selector-wide">

            {/* ── Page header ───────────────────────────────────── */}
            <div className="time-page-header">
              <div className="time-page-header-icon" style={{ background: '#27ae60' }}>
                <CheckCircle size={24} strokeWidth={2} />
              </div>
              <div className="time-page-header-text">
                <h2>{t('¡Reserva confirmada!')}</h2>
                <p>{t('Tu taquilla está lista. Guarda tu código de acceso.')}</p>
              </div>
              <span className="time-page-header-step">5 / 5</span>
            </div>

            {/* ── 2-column layout ───────────────────────────────── */}
            <div className="time-ticket-cols">

              {/* LEFT: locker № · access code · open button */}
              <div className="time-ticket-col-left">

                <div className="time-ticket-big-card" style={{ borderColor: iconsColor }}>
                  <span className="time-ticket-card-label">{t('Número de taquilla')}</span>
                  <div className="time-ticket-big-display" style={{ color: iconsColor }}>
                    {lockerMatricula || '—'}
                  </div>
                  <span className="time-ticket-card-sub">{this.getLockerType(selectedLocker)}</span>
                </div>

                <div className="time-ticket-big-card" style={{ borderColor: iconsColor }}>
                  <span className="time-ticket-card-label">{t('Código de acceso')}</span>
                  <div className="time-ticket-big-display" style={{ color: iconsColor }}>
                    {accessCode || '----'}
                  </div>
                  <span className="time-ticket-card-sub" style={{ marginTop: '10px' }}>
                    📱 {t('Necesitas el código y tu teléfono para acceder de nuevo.')}
                  </span>
                  <div className="time-ticket-phone-display" style={{ color: iconsColor }}>
                    {phoneNumber}
                  </div>
                  <span className="time-ticket-card-hint">
                    📸 {t('Haz una captura de pantalla. También recibirás esta información por email.')}
                  </span>
                </div>

                <div className="time-open-section">
                  {isReload ? (
                    <div className="time-open-reload-alert">
                      <div className="time-open-reload-icon">⚠️</div>
                      <p className="time-open-reload-msg">
                        {t('Para abrir tu taquilla usa tus credenciales: número de taquilla, teléfono y código de acceso.')}
                      </p>
                      <button
                        className="time-continue-btn"
                        style={buttonStyle}
                        onClick={() => { if (this.unblockHistory) this.unblockHistory(); this.props.push(`/timeAccessView/${qrToken}`); }}
                      >
                        🔓 {t('IR A ABRIR TAQUILLA')}
                      </button>
                    </div>
                  ) : lockerMustOpen ? (
                    <div className="time-open-required">
                      <p className="time-open-warning">
                        {t('Debes abrir la taquilla antes de salir de esta pantalla')}
                        <button className="time-continue-btn" style={buttonStyle} onClick={this.toggleOpenPopup}>
                        🔓 {t('ABRIR TAQUILLA')}
                        </button>
                      </p>
                    </div>
                  ) : (
                    <div className="time-open-done">
                      <div className="time-done-icon">✓</div>
                      <p>{t('Taquilla abierta correctamente')}</p>
                      <button className="time-continue-btn" style={buttonStyle} onClick={this.handleFinish}>
                        {t('FINALIZAR')}
                      </button>
                    </div>
                  )}
                </div>

              </div>

              {/* RIGHT: summary + download invoice */}
              <div className="time-ticket-col-right">

                <div className="time-phone-card">
                  <h5 className="time-summary-header">{t('Resumen del alquiler')}</h5>

                  {customerName && (
                    <div className="time-summary-row">
                      <span>{t('Nombre')}</span>
                      <strong>{customerName}</strong>
                    </div>
                  )}
                  <div className="time-summary-row">
                    <span>{t('Teléfono')}</span>
                    <strong>{phoneNumber}</strong>
                  </div>
                  {customerEmail && (
                    <div className="time-summary-row">
                      <span>{t('Email')}</span>
                      <strong style={{ wordBreak: 'break-all', fontSize: '0.85rem' }}>{customerEmail}</strong>
                    </div>
                  )}
                  <div className="time-summary-row">
                    <span>{t('Tiempo alquilado')}</span>
                    <strong>{timeDisplay}</strong>
                  </div>
                  <div className="time-summary-row">
                    <span>{t('Cortesía')}</span>
                    <strong>+{courtesyTime} min</strong>
                  </div>
                  <div className="time-summary-row">
                    <span>{t('Inicio')}</span>
                    <strong>{fmtTime(rentStartTime)}</strong>
                  </div>
                  <div className="time-summary-row">
                    <span>{t('Fin')}</span>
                    <strong>{fmtTime(rentEndTime)}</strong>
                  </div>

                  <div className="time-summary-divider"></div>

                  <div className="time-summary-row">
                    <span>{t('Base imponible')}</span>
                    <span>{(importeBase || 0).toFixed(2)} €</span>
                  </div>
                  <div className="time-summary-row">
                    <span>{t('IVA')} ({iva}%)</span>
                    <span>{(importeIva || 0).toFixed(2)} €</span>
                  </div>
                  <div className="time-summary-divider"></div>
                  <div className="time-summary-row time-summary-total">
                    <span>{t('TOTAL')}</span>
                    <strong>{(total || 0).toFixed(2)} €</strong>
                  </div>

                  {lockerInvoice && (
                    <div className="time-summary-row" style={{ marginTop: '4px' }}>
                      <span>{t('Nº Factura')}</span>
                      <span style={{ fontFamily: 'monospace', fontSize: '0.82rem' }}>{lockerInvoice}</span>
                    </div>
                  )}
                  {this.state.gpAuthCode && (
                    <div className="time-summary-row" style={{ marginTop: '4px' }}>
                      <span>{t('Autorización')}</span>
                      <span style={{ fontFamily: 'monospace', fontSize: '0.82rem' }}>{this.state.gpAuthCode}</span>
                    </div>
                  )}
                </div>

                <button
                  className="time-invoice-btn"
                  onClick={this.handleDownloadInvoice}
                  disabled={!lockerInvoice}
                  title={!lockerInvoice ? t('Generando factura...') : undefined}
                >
                  <Download size={16} style={{ marginRight: '8px', verticalAlign: 'middle' }} />
                  {lockerInvoice ? t('DESCARGAR FACTURA PDF') : t('Generando factura...')}
                </button>

              </div>
            </div>

          </div>
        </div>
        <StepBarTime step={5} />

        {/* ── Open Locker Modal ──────────────────────────────────── */}
        <Modal isOpen={isOpenPopup} toggle={this.toggleOpenPopup}>
          {isOpened ? (
            <ModalBody className="text-center time-modal">
              <div className="time-modal-icon time-success">✓</div>
              <h3>{t('¡TAQUILLA ABIERTA!')}</h3>
              <img src="/images/lockerOpen.png" alt="Open" className="time-modal-img" />
              <p>{t('Tu taquilla está abierta. Guarda tus pertenencias y ciérrala.')}</p>
              <button className="time-modal-btn" style={buttonStyle} onClick={this.toggleOpenPopup}>
                {t('ACEPTAR')}
              </button>
            </ModalBody>
          ) : openError ? (
            <ModalBody className="text-center time-modal">
              <div className="time-modal-icon time-error">✕</div>
              <h3>{t('Error al abrir')}</h3>
              <p>{t('No se ha podido abrir la taquilla. Inténtalo de nuevo.')}</p>
              <button className="time-modal-btn" onClick={() => {
                this.setState({ openError: false });
                this.handleOpenLocker();
              }}>
                {t('REINTENTAR')}
              </button>
            </ModalBody>
          ) : isOpening ? (
            <ModalBody className="text-center time-modal">
              <h3>{t('ABRIENDO TAQUILLA')}</h3>
              <p>{t('Por favor, mantente cerca de tu taquilla.')}</p>
              <div className="time-countdown" style={{ color: primaryColor }}>
                {minutes.toString().padStart(2, '0')}:{seconds.toString().padStart(2, '0')}
              </div>
              <div className="spinner"><img src="/images/logo.png" alt="Logo" /></div>
            </ModalBody>
          ) : (
            <ModalBody className="text-center time-modal">
              <h3>{t('¡LEER ANTES DE ABRIR!')}</h3>
              <div className="time-modal-instructions">
                <p>• {t('Confirma que estás delante de la taquilla.')}</p>
                <p>• {t('La taquilla se abrirá automáticamente.')}</p>
                <p>• {t('Guarda tus pertenencias y cierra la puerta.')}</p>
              </div>
              <button className="time-modal-btn time-btn-primary" style={buttonStyle} onClick={this.handleOpenLocker}>
                {t('ABRIR AHORA')}
              </button>
              <button className="time-modal-btn time-btn-cancel" onClick={this.toggleOpenPopup}>
                {t('CANCELAR')}
              </button>
              <p className="time-modal-disclaimer">
                {t('*Vacway no se hace responsable del mal uso de esta funcionalidad.')}
              </p>
            </ModalBody>
          )}
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  auth: true,
  qrData: state.qrs.qr
})

const mapDispatchToProps = dispatch => ({
  push: bindActionCreators(push, dispatch),
  postTimeRent: bindActionCreators(postTimeRent, dispatch),
  postTimeOpen: bindActionCreators(postTimeOpen, dispatch),
  fetchTimeOpenStatus: bindActionCreators(fetchTimeOpenStatus, dispatch),
  postRedsysGetParams: bindActionCreators(postRedsysGetParams, dispatch),
  fetchCustomer: bindActionCreators(fetchCustomer, dispatch),
  postQrsale: bindActionCreators(postQrsale, dispatch),
})

export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(TicketTimeView));
